module.exports = __webpack_public_path__ + "assets/ebe4616cb81966dfcacd2d4d932f509f.mp4";